var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.avocado_een{fill:#231F20;}\r\n\t.avocado_drie{fill:#716558;}\r\n\t.avocado_vier{fill:#AF9480;}\r\n\t.st0{fill:#FFFAEE;}\r\n\t.st1{fill:#3D3935;}\r\n\t.st2{fill:#E0A838;}\r\n\t.st3{fill:#DBD2C1;}\r\n\t.st4{fill:#A3AEB5;}\r\n\t.st5{fill:#788287;}\r\n\t.st6{fill:#EAD13F;}\r\n\t.st7{fill:#D1712A;}\r\n\t.st8{fill:#CC4121;}\r\n\t.st9{fill:#8D3E93;}\r\n\t.st10{fill:#248EBC;}\r\n\t.st11{fill:#6F9B45;}\r\n\t.st12{fill:#C3CC6A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "avocado_vier",
    points: "27.477,30.5 26.522,9.5 5.478,9.5 4.523,30.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "avocado_drie",
    d: "M16,3.5c1.93,0,3.5,1.57,3.5,3.5v2.5h2V7c0-3.033-2.467-5.5-5.5-5.5S10.5,3.967,10.5,7v2.5h2V7 C12.5,5.07,14.07,3.5,16,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "avocado_een",
    d: "M27,9h-5V7c0-3.314-2.686-6-6-6s-6,2.686-6,6v2H5L4,31h24L27,9z M11,7c0-2.757,2.243-5,5-5 s5,2.243,5,5v2h-1V7c0-2.206-1.794-4-4-4s-4,1.794-4,4v2h-1V7z M19,9h-6V7c0-1.657,1.343-3,3-3s3,1.343,3,3V9z M5.047,30l0.909-20 h20.089l0.909,20H5.047z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.d2333776778f7eb3dcc34a253f32512d.svg";
export { ForwardRef as ReactComponent };